import React from "react";

const ProvidedAccountDetails = ({ setAccountNumber,  setSortCode, hideValidationAccountNumber, hideValidationSortCode, price }) => {

    const textBoxKeyPress = (event) => {
        if (event.keyCode >= 32 && event.keyCode !== 37 && event.keyCode !== 39 &&
            !(!event.nativeEvent.ctrlKey && event.nativeEvent.key === 'Delete') &&
            !(!event.nativeEvent.ctrlKey && event.nativeEvent.key === 'Home') &&
            !(!event.nativeEvent.ctrlKey && event.nativeEvent.key === 'End')) {
            if (event.key === '+' ||
                event.key === '-' ||
                event.key === 'e') {
                event.preventDefault();
            }
            if (event.key < '0' || event.key > '9') {
                event.preventDefault();
            }
            if (event.target.value?.length >= 8) {
                event.preventDefault();
            }
        }
    }

    const sortCodeKeyPress = (event) => {
        if (event.keyCode >= 32 && event.keyCode !== 37 && event.keyCode !== 39 && event.keyCode !== '-' &&
            !(!event.nativeEvent.ctrlKey && event.nativeEvent.key === 'Delete') &&
            !(!event.nativeEvent.ctrlKey && event.nativeEvent.key === 'Home') &&
            !(!event.nativeEvent.ctrlKey && event.nativeEvent.key === 'End')) {
            if (event.key === '+' ||
                event.key === '-' ||
                event.key === 'e') {
                event.preventDefault();
            }
            if (event.key < '0' || event.key > '9') {
                event.preventDefault();
            }
            if (event.target.value?.length >= 8) {
                event.preventDefault();
            }
            if (event.target.value?.length === 2 || event.target.value?.length === 5) {
                event.target.value += '-';
            }
        }
    }

    return (
        <div data-testid="provided-account-details">
            <div className="row pt-5">
                <div className="col-6 fw-bold">
                    Please enter the account details the law firm has provided
                </div>
            </div>
            <div className="row">
                &nbsp;
            </div>
            <div className="row">
                <div className="col-6">
                    Account Number
                </div>
            </div>
            <div className="row">
                <div className="col-3">
                    <input required type="text" maxLength="10" onChange={(event) => setAccountNumber(event.target.value)} onKeyDown={textBoxKeyPress} className="form-control" id="account-number" placeholder="8 digits" />
                </div>
            </div>
            <div className="row">
                <div className="col-6 text-danger">
                    {hideValidationAccountNumber ? (<>&nbsp;</>) : (
                        <span data-testid="provided-account-details-acc-num-validation">You have not entered the required information </span>)}
                </div>
            </div>
            <div className="row pt-1">
                <div className="col-6">
                    Sort code
                </div>
            </div>
            <div className="row">
                <div className="col-3">
                    <input required type="text" maxLength="8" onChange={(event) => setSortCode(event.target.value)} onKeyDown={sortCodeKeyPress} className="form-control" id="sort-code" placeholder="00-00-00" />
                </div>
            </div>
            <div className="row">
                <div className="col-6 text-danger">
                    {hideValidationSortCode ? (<>&nbsp;</>) : (
                        <span data-testid="provided-account-details-sort-code-validation">You have not entered the required information </span>)}
                </div>
            </div>
            <div className="row mt-3 pt-3">
                <div className="col-12">
                    You are giving LMS consent to collect a fee of &pound;{price.toFixed(2)} (plus VAT) which will be collected by the agreed payment method in line with your current LMS Panel Link Direct Debit Terms and Conditions.
                </div>
            </div>
        </div>
    );
}

export default ProvidedAccountDetails;